import { render, staticRenderFns } from "./ResetPwd.vue?vue&type=template&id=4104e526&scoped=true&"
import script from "./ResetPwd.vue?vue&type=script&lang=js&"
export * from "./ResetPwd.vue?vue&type=script&lang=js&"
import style0 from "./ResetPwd.vue?vue&type=style&index=0&id=4104e526&lang=scss&scoped=true&"
import style1 from "styles/dashboard/style.scss?vue&type=style&index=1&id=4104e526&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4104e526",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4104e526')) {
      api.createRecord('4104e526', component.options)
    } else {
      api.reload('4104e526', component.options)
    }
    module.hot.accept("./ResetPwd.vue?vue&type=template&id=4104e526&scoped=true&", function () {
      api.rerender('4104e526', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/ResetPwd.vue"
export default component.exports